/**
 * pf-countdown-deadline.js — formats the offer's live countdown deadline
 * (set by lp-countdown-banner.liquid as window.__lpCountdownDeadline) as a
 * "Month Day" string for use in copy like "Orders By {deadline_date}!".
 * Falls back to now + 24h if the countdown banner isn't present on the page.
 *
 * Shared between shop-section-reimagined-pdp-offer.liquid (step 1) and
 * shop-section-reimagined-pdp-offer-step2.liquid (step 2).
 */
function formatDeadlineDate() {
  var deadline = window.__lpCountdownDeadline || (Date.now() + 24 * 60 * 60 * 1000);
  var d = new Date(deadline);
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var day = d.getDate();
  var suffix = 'th';
  if (day % 10 === 1 && day !== 11) suffix = 'st';
  else if (day % 10 === 2 && day !== 12) suffix = 'nd';
  else if (day % 10 === 3 && day !== 13) suffix = 'rd';
  return months[d.getMonth()] + ' ' + day + suffix;
}
